// 간편접수 폼 모드 — 간단(기본) · 상세(공사 종류·예산대·통화 가능 시간 추가). 대표만 바꾼다.

import { useState, useTransition } from "react";
import { toast } from "sonner";

import { InstantSaveNote } from "@/components/save-bar";
import SectionCard from "@buildpy/ui/section-card";
import { Radio } from "@buildpy/ui/radio";
import { settleRedirect } from "@/lib/redirect-error";
import { INTAKE_MODE_LABEL, INTAKE_MODES, IntakeMode } from "@buildpy/core/modules/customer/intake-detail";
import { saveIntakeMode } from "@/api/actions/org";

const MODE_HINT: Record<IntakeMode, string> = {
  simple: "이름·연락처·주소·거주형태·평형대·요청 사항",
  detail: "간단 칸에 공사 종류·예산대·통화 가능 시간을 더합니다",
};

interface Props {
  canEdit: boolean;
  mode: IntakeMode;
}

const SettingsIntakeMode = ({ canEdit, mode }: Props) => {
  const [value, setValue] = useState<IntakeMode>(mode);
  const [pending, startTransition] = useTransition();

  const onPick = (next: IntakeMode) => {
    if (next === value) return;
    const prev = value;
    setValue(next);
    startTransition(async () => {
      try {
        const result = await saveIntakeMode(next);
        if (result.ok) toast.success(result.message);
        else {
          toast.error(result.message);
          setValue(prev);
        }
      } catch (caught) {
        if (settleRedirect(caught)) return;
        toast.error("저장하지 못했습니다. 잠시 후 다시 시도하세요.");
        setValue(prev);
      }
    });
  };

  return (
    <SectionCard
      actions={canEdit ? <InstantSaveNote /> : undefined}
      data-testid="settings-intake-mode"
      description="고객이 여는 간편접수 폼에 어떤 칸을 보일지 고릅니다. 상세 칸은 전부 선택 입력입니다."
      title="간편접수 폼">
      <fieldset className="flex flex-col gap-y-2" disabled={!canEdit || pending}>
        <legend className="sr-only">간편접수 폼 모드</legend>
        {INTAKE_MODES.map((option) => (
          <label key={option} className="flex min-h-10 items-center gap-x-2 text-sm">
            <Radio
              checked={value === option}
              name="intake-mode"
              onChange={() => onPick(option)}
              value={option}
            />
            <span className="font-medium">{INTAKE_MODE_LABEL[option]}</span>
            <span className="text-muted-foreground">— {MODE_HINT[option]}</span>
          </label>
        ))}
      </fieldset>
    </SectionCard>
  );
};

export default SettingsIntakeMode;
